import type { ProductPreviewRow } from './types';

export type ProductsStockAlertLevel = 'success' | 'warning' | 'danger';

export interface ProductsStockAlert {
    level: ProductsStockAlertLevel;
}

const coveredQty = (row: ProductPreviewRow) => {
    if (row.alreadyOnObject) return Number(row.existingCount || 0);
    return Number(row.transferCount || 0);
};

/**
 * green — усі товари повністю покриті (залишками джерел + вже в матеріалах)
 * yellow — є товари з нестачею
 * red — товарів немає взагалі
 */
export const getProductsStockAlert = (
    rows: ProductPreviewRow[],
): ProductsStockAlert => {
    if (!rows.length) {
        return { level: 'danger' };
    }

    const byProduct = new Map<number, { need: number; covered: number }>();
    for (const row of rows) {
        const existing = byProduct.get(row.productId);
        if (!existing) {
            byProduct.set(row.productId, {
                need: row.need,
                covered: coveredQty(row),
            });
        } else {
            existing.covered += coveredQty(row);
        }
    }

    const hasShortage = Array.from(byProduct.values()).some(
        (item) => item.covered < item.need,
    );

    return { level: hasShortage ? 'warning' : 'success' };
};
